// ✅ Phase 2 — Dairəvi avatar göstəricisi (CSS qradient + ikon).
// Şəkil yükləmə yoxdur. avatarId verilmirsə default avatar_1 göstərilir.

import React from 'react'
import { getAvatarById } from '../../utils/avatars'

const SIZES = {
    xs: { box: 'h-7 w-7',   icon: 13 },
    sm: { box: 'h-9 w-9',   icon: 16 },
    md: { box: 'h-12 w-12', icon: 22 },
    lg: { box: 'h-20 w-20', icon: 38 },
    xl: { box: 'h-28 w-28', icon: 54 }
}

const AvatarBadge = ({ avatarId, size = 'md', selected = false, className = '' }) => {
    const avatar = getAvatarById(avatarId)
    const { box, icon } = SIZES[size] || SIZES.md
    const { Icon, gradient } = avatar

    return (
        <span
            className={`inline-flex ${box} items-center justify-center rounded-full bg-gradient-to-br ${gradient} text-white shadow-sm ${selected ? 'ring-4 ring-offset-2 ring-brand-500' : ''} ${className}`}
            aria-label={avatar.label}
            title={avatar.label}
        >
            <Icon size={icon} />
        </span>
    )
}

export default AvatarBadge
